import { render, staticRenderFns } from "./AddConceptSubcategoryModal.vue?vue&type=template&id=6128546f"
import script from "./AddConceptSubcategoryModal.vue?vue&type=script&lang=js"
export * from "./AddConceptSubcategoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6128546f')) {
      api.createRecord('6128546f', component.options)
    } else {
      api.reload('6128546f', component.options)
    }
    module.hot.accept("./AddConceptSubcategoryModal.vue?vue&type=template&id=6128546f", function () {
      api.rerender('6128546f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/AddConceptSubcategoryModal.vue"
export default component.exports